import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import $ from 'jquery'

gsap.registerPlugin(ScrollTrigger)

$(function(){
    gsap.utils.toArray(".hanayama90--fadein").forEach(target => {
      gsap.fromTo(target,
        {
            autoAlpha: 0, // 要素を隠す
            y: 30 // 縦方向に+30px
        },
        {
            autoAlpha: 1, // 要素を表示
            duration: 1, // 1秒かけてアニメーション
            y: 0, // 縦方向0に
            scrollTrigger: { // scrollTriggerの設定
                trigger: target, // ターゲットとなる要素を指定
                start: 'top center+=25%', // アニメーションの開始位置を設定。
                // markers: true, 
            }
        });
     });
  });